import { Outlet } from "react-router-dom"





const CustomersManagement = () => {

    return (
        <div>
            <Outlet />
        </div>
    )
}

export default CustomersManagement;